<template>
  <div class="d-flex align-center gap-2">
    <v-switch
      v-model="publishedToWeb"
      inset
      color="primary"
      label="Published to web"
      :disabled="!isEditAllowed"
      hide-details
      class="mt-0 pt-0"
    />
    <v-tooltip v-if="!isEditAllowed" bottom>
      <template #activator="{ on, attrs }">
        <v-icon v-bind="attrs" class="cursor-pointer" v-on="on">
          mdi-information-outline
        </v-icon>
      </template>
      <span>{{ tooltipText }}</span>
    </v-tooltip>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';

export default Vue.extend({
  name: 'ContactPublishToWebSwitch',

  props: {
    value: Boolean,
    isInternal: Boolean,
  },

  computed: {
    publishedToWeb: {
      get (): boolean {
        return this.value;
      },
      set (value: boolean) {
        this.$emit('input', value)
      }
    },
    isEditAllowed (): boolean {
      // @ts-ignore
      return this.isAdmin && this.isInternal;
    },
    tooltipText (): string {
      // @ts-ignore
      if (!this.isAdmin) {
        return 'You are not an admin and cannot publish contacts to the web.';
      }

      if (!this.isInternal) {
        return 'This contact is not internal and cannot be published to the web.';
      }

      return '';
    }
  }
})
</script>
